import styled from '@emotion/styled';
import {
    colorVariables,
    gutterSizes,
    fontSizes,
    fontWeights,
    lineHeights,
    colors,
} from '../base/theme';

export const AccordionContainer = styled.div`
    border-bottom: 1px solid ${colorVariables.borderLight};
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);

    .filter-content {
        margin: ${gutterSizes.base} ${gutterSizes.large} ${gutterSizes.large};
    }
`;

export const AccordionHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    font-size: ${fontSizes.base};
    line-height: ${lineHeights.base};
    font-weight: ${fontWeights.bold};
    padding: ${gutterSizes.large};
    color: ${colors.bark};

    .icon {
        font-size: ${fontSizes.medium};
        font-weight: ${fontWeights.normal};
        color: ${colors.bark80};
    }
`;
